var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card container-fluid d-flex flex-column",class:{
    'align-items-start': _vm.align === 'left',
    'align-items-center': _vm.align === 'center',
    'align-items-end': _vm.align === 'right',
    'smooth-display': _vm.smoothDisplay
  },style:({'pointer-events': _vm.preloadingMask ? 'none' : 'inherit'})},[(_vm.preloadingMask)?_c('div',{staticClass:"preloading-mask"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }